import * as i0 from '@angular/core';
import { Input, Optional, Component, Directive, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i4 from '@yourcause/common/core-forms';
import { FormControlComponent, CoreFormsModule } from '@yourcause/common/core-forms';
import * as i2 from '@yourcause/common/i18n';
import { TextTransform, I18nModule } from '@yourcause/common/i18n';
import * as i3 from '@yourcause/common/utils';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@yourcause/common/icons';
import { IconsModule } from '@yourcause/common/icons';

class SelectComponent extends FormControlComponent {
    constructor(formGroupDirective, i18n, ahs, formControlService) {
        super(formGroupDirective, formControlService);
        this.formGroupDirective = formGroupDirective;
        this.i18n = i18n;
        this.ahs = ahs;
        this.options = [];
        this.controlled = false;
        this.disableOnEmpty = false;
        this.isLocked = false;
        this.rounded = false;
        this.sorted = true;
        this.disabled = false;
        this.hideBorder = false;
        this._disabled = false;
        this.noValueSelected = false;
        this._initialized = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.options = this.options || [];
        this.options.forEach((option) => {
            if (option.displayKey && !option.display) {
                option.display = this.i18n.getDefault(option.displayKey, TextTransform.SentenceCase);
            }
        });
        if (this.sorted) {
            this.options = this.ahs.sort(this.options, 'display');
        }
        let index = this.options.indexOf(this.options.find(({ value }) => value === this._value));
        if (index === -1) {
            this.noValueSelected = true;
        }
        if (!this.controlled && this.noValueSelected) {
            index = 0;
            this._onChange(index);
        }
        this._valueIndex = index;
        this._initialized = true;
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.options) {
            if (this.disableOnEmpty) {
                this._disabled = simpleChanges.options.currentValue.length === 0;
            }
            if (this._initialized &&
                simpleChanges.options.previousValue &&
                (simpleChanges.options.previousValue !== simpleChanges.options.currentValue)) {
                if (simpleChanges.options.currentValue[0] &&
                    !this.controlled &&
                    !simpleChanges.options.currentValue.includes(this._value)) {
                    this.control.setValue(simpleChanges.options.currentValue[0].value);
                }
                this.ngOnInit();
            }
        }
    }
    _doOnChange(value, fromControlChange = false) {
        const valueIndex = this.options.findIndex(option => option.value === value);
        value = this.getOptionFromIndex(valueIndex);
        super._doOnChange(value ? value.value : value, fromControlChange);
    }
    getOptionFromIndex(valueIndex) {
        const foundOption = this.options[+valueIndex];
        this._valueIndex = valueIndex;
        // if we found the option in the picklist
        if (foundOption) {
            this.noValueSelected = false;
            // if we couldn't find the default selected value
            // and there is a default passed in, use that
        }
        else if (this.defaultSelectValue) {
            this.noValueSelected = true;
            // otherwise pick the first option
        }
        else if (!this.controlled && this.options[0]) {
            return this.getOptionFromIndex(0);
        }
        if (foundOption) {
            return foundOption;
        }
    }
    _onChange(valueIndex) {
        const value = this.getOptionFromIndex(valueIndex);
        if (value) {
            super._onChange(value.value);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectComponent, deps: [{ token: i1.FormGroupDirective, optional: true }, { token: i2.I18nService }, { token: i3.ArrayHelpersService }, { token: i4.FormControlService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: SelectComponent, isStandalone: false, selector: "yc-select", inputs: { options: "options", defaultSelectValue: "defaultSelectValue", controlled: "controlled", disableOnEmpty: "disableOnEmpty", isLocked: "isLocked", rounded: "rounded", sorted: "sorted", disabled: "disabled", hideBorder: "hideBorder" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<!-- IN PROGRESS; WRAPPER FOR SELECTS -->\n<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n  <div class=\"form-input-wrapper\" [class.round-select]=\"rounded\">\n\n    <select\n      class=\"yc-component form-control\"\n      [class.hide-border]=\"hideBorder\"\n      [id]=\"name\"\n      [ngModel]=\"_valueIndex\"\n      [disabled]=\"disabled || _disabled || control?.disabled\"\n      (ngModelChange)=\"_onChange($event)\"\n      [tabindex]=\"tabIndex\"\n      (focus)=\"_onFocus($event)\">\n      <option\n        *ngIf=\"defaultSelectValue && noValueSelected\"\n        [value]=\"-1\">\n        {{ defaultSelectValue }}\n      </option>\n\n      <option\n        *ngFor=\"let option of options; let i = index;\"\n        [value]=\"i\">\n        {{ option.displayKey ?\n          (option.displayKey | ycI18n:option.display) :\n          option.display ? option.display : option.label\n        }}\n      </option>\n\n    </select>\n  \n    <yc-fa \n      class=\"yc-input-status-icon\" \n      icon=\"exclamation-circle\">\n    </yc-fa>\n    <yc-fa \n      class=\"yc-input-status-icon\" \n      icon=\"check-circle\">\n    </yc-fa>\n    <yc-fa *ngIf=\"isLocked\" \n      class=\"yc-input-status-icon\"\n      icon=\"lock\">\n    </yc-fa>\n  </div>\n\n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>", styles: [".inline-select{display:inline-flex}.yc-component.form-control.hide-border{border:none}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.FormLabelComponent, selector: "yc-form-label", inputs: ["name", "label", "srOnly", "description", "tabIndex", "cursorStyle", "tooltipText", "popoverTemplate", "showQuestionMarkForTooltip", "asteriskForRequired", "forRadioButtons", "customIcon", "customIconTooltip", "customIconClass", "forFileUpload", "triggerUpload"] }, { kind: "component", type: i4.FormHelpOrErrorComponent, selector: "yc-form-help-or-error", inputs: ["error", "customError", "showError", "showHelp", "help", "helpTextClass"] }, { kind: "component", type: i6.FontAwesomeComponent, selector: "yc-fa", inputs: ["color", "icon", "tooltipText", "popoverTemplate", "light", "regular", "solid"], outputs: ["onClick"] }, { kind: "directive", type: i1.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "pipe", type: i2.I18nPipe, name: "ycI18n" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'yc-select', standalone: false, template: "<!-- IN PROGRESS; WRAPPER FOR SELECTS -->\n<div class=\"form-group\"\n  [class.mb-0]=\"noMarginBottom\"\n  [class.ng-invalid]=\"!!(error || customError) && isDirty\">\n  <yc-form-label\n    [srOnly]=\"srOnlyLabel\"\n    [name]=\"name\"\n    [label]=\"label\"\n    [description]=\"description\"\n    [tooltipText]=\"tooltipText\"\n    [popoverTemplate]=\"popoverTemplate\"\n    [showQuestionMarkForTooltip]=\"showQuestionMarkForTooltip\"\n    [asteriskForRequired]=\"addRequiredAsterisk\"\n    [customIcon]=\"customLabelIcon\"\n    [customIconTooltip]=\"customLabelIconTooltip\"\n    [customIconClass]=\"customLabelIconClass\">\n  </yc-form-label>\n  <div class=\"form-input-wrapper\" [class.round-select]=\"rounded\">\n\n    <select\n      class=\"yc-component form-control\"\n      [class.hide-border]=\"hideBorder\"\n      [id]=\"name\"\n      [ngModel]=\"_valueIndex\"\n      [disabled]=\"disabled || _disabled || control?.disabled\"\n      (ngModelChange)=\"_onChange($event)\"\n      [tabindex]=\"tabIndex\"\n      (focus)=\"_onFocus($event)\">\n      <option\n        *ngIf=\"defaultSelectValue && noValueSelected\"\n        [value]=\"-1\">\n        {{ defaultSelectValue }}\n      </option>\n\n      <option\n        *ngFor=\"let option of options; let i = index;\"\n        [value]=\"i\">\n        {{ option.displayKey ?\n          (option.displayKey | ycI18n:option.display) :\n          option.display ? option.display : option.label\n        }}\n      </option>\n\n    </select>\n  \n    <yc-fa \n      class=\"yc-input-status-icon\" \n      icon=\"exclamation-circle\">\n    </yc-fa>\n    <yc-fa \n      class=\"yc-input-status-icon\" \n      icon=\"check-circle\">\n    </yc-fa>\n    <yc-fa *ngIf=\"isLocked\" \n      class=\"yc-input-status-icon\"\n      icon=\"lock\">\n    </yc-fa>\n  </div>\n\n  <yc-form-help-or-error\n    [error]=\"error\"\n    [customError]=\"customError\"\n    [showError]=\"showError\"\n    [showHelp]=\"showHelp\"\n    [help]=\"help\"\n    [helpTextClass]=\"helpTextClass\">\n  </yc-form-help-or-error>\n</div>", styles: [".inline-select{display:inline-flex}.yc-component.form-control.hide-border{border:none}\n"] }]
        }], ctorParameters: () => [{ type: i1.FormGroupDirective, decorators: [{
                    type: Optional
                }] }, { type: i2.I18nService }, { type: i3.ArrayHelpersService }, { type: i4.FormControlService }], propDecorators: { options: [{
                type: Input
            }], defaultSelectValue: [{
                type: Input
            }], controlled: [{
                type: Input
            }], disableOnEmpty: [{
                type: Input
            }], isLocked: [{
                type: Input
            }], rounded: [{
                type: Input
            }], sorted: [{
                type: Input
            }], disabled: [{
                type: Input
            }], hideBorder: [{
                type: Input
            }] } });

class SelectOptionLabelTemplateDirective {
    constructor(templateRef, viewRef) {
        this.templateRef = templateRef;
        this.viewRef = viewRef;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectOptionLabelTemplateDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "19.2.10", type: SelectOptionLabelTemplateDirective, isStandalone: false, selector: "[ycSelectOptionLabelTemplate]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectOptionLabelTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ycSelectOptionLabelTemplate]',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }] });

class SelectModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: SelectModule, declarations: [SelectComponent,
            SelectOptionLabelTemplateDirective], imports: [CommonModule,
            CoreFormsModule,
            IconsModule,
            I18nModule,
            FormsModule], exports: [SelectComponent,
            SelectOptionLabelTemplateDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectModule, imports: [CommonModule,
            CoreFormsModule,
            IconsModule,
            I18nModule,
            FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: SelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoreFormsModule,
                        IconsModule,
                        I18nModule,
                        FormsModule
                    ],
                    declarations: [
                        SelectComponent,
                        SelectOptionLabelTemplateDirective
                    ],
                    exports: [
                        SelectComponent,
                        SelectOptionLabelTemplateDirective
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SelectComponent, SelectModule, SelectOptionLabelTemplateDirective };
